import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AppointmentDto, PropertyApplicationDto, PropertyDto } from '@workspace/data-types';
import { DiscussionVisitCardComponent } from '../discussion-visit-card/discussion-visit-card.component';

export interface DiscussionVisitDialogData {
  appointment: AppointmentDto | null;
  application: PropertyApplicationDto | null;
  isOwner: boolean;
  property: PropertyDto | null;
}

export type DiscussionVisitDialogResult =
  | { action: 'proposeVisit' }
  | { action: 'confirmSlot'; slotId: string }
  | { action: 'requestReschedule'; reason?: string }
  | { action: 'markAsVisited' }
  | { action: 'reportNoShow'; reason?: string };

@Component({
  selector: 'etxe-discussion-visit-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, DiscussionVisitCardComponent],
  templateUrl: './discussion-visit-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscussionVisitDialogComponent {
  readonly data = inject<DiscussionVisitDialogData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<DiscussionVisitDialogComponent, DiscussionVisitDialogResult>);

  onConfirmSlot(slotId: string): void {
    this.dialogRef.close({ action: 'confirmSlot', slotId });
  }

  onRequestReschedule(reason?: string): void {
    this.dialogRef.close({ action: 'requestReschedule', reason });
  }

  onProposeVisit(): void {
    this.dialogRef.close({ action: 'proposeVisit' });
  }

  onMarkAsVisited(): void {
    this.dialogRef.close({ action: 'markAsVisited' });
  }

  onReportNoShow(reason?: string): void {
    this.dialogRef.close({ action: 'reportNoShow', reason });
  }

  close(): void {
    this.dialogRef.close();
  }
}
